import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
interface LineChartVisualProps {
  data: Array<{
    label: string;
    value: number;
  }>;
  xAxisLabel?: string;
  yAxisLabel?: string;
  lineColor?: string;
  hideValues?: boolean;
  mode?: 'stimulus' | 'support';
}
export function LineChartVisual({
  data,
  xAxisLabel = '',
  yAxisLabel = '',
  lineColor = '#6366f1',
  hideValues = true,
  mode = 'stimulus'
}: LineChartVisualProps) {
  const effectiveHideValues = mode === 'support' ? false : hideValues;
  const CustomTooltip = ({
    active,
    payload
  }: {
    active?: boolean;
    payload?: Array<{
      payload: {
        label: string;
        value: number;
      };
    }>;
  }) => {
    if (!active || !payload?.[0]) return null;
    const item = payload[0].payload;
    return <div className="bg-white px-3 py-2 rounded-lg shadow-lg border border-slate-200 text-sm" data-id="element-8203">
        <span className="font-semibold text-slate-700" data-id="element-8204">{item.label}</span>
        {!effectiveHideValues && <span className="text-slate-500 ml-2" data-id="element-8205">{item.value}</span>}
      </div>;
  };
  return <div className="w-full max-w-3xl mx-auto flex flex-col items-center" data-id="element-8206">
      <div className="w-full h-[240px] md:h-[340px] bg-white rounded-xl border border-slate-200 shadow-sm p-3 md:p-4" aria-hidden="true" data-id="element-8207">
        <ResponsiveContainer width="100%" height="100%" data-id="element-8208">
          <LineChart data={data} margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 40
        }} data-id="element-8209">
            <CartesianGrid strokeDasharray="3 3" vertical={false} data-id="element-8210" />
            <XAxis dataKey="label" interval={0} tick={{
            fill: '#64748b',
            fontSize: 12
          }} tickLine={false} axisLine={{
            stroke: '#cbd5e1'
          }} label={xAxisLabel ? {
            value: xAxisLabel,
            position: 'insideBottom',
            offset: -20,
            fill: '#475569',
            fontSize: 13,
            fontWeight: 600
          } : undefined} data-id="element-8211" />
            <YAxis tick={{
            fill: '#64748b',
            fontSize: 12
          }} tickLine={false} axisLine={false} label={yAxisLabel ? {
            value: yAxisLabel,
            angle: -90,
            position: 'insideLeft',
            fill: '#475569',
            fontSize: 14,
            fontWeight: 600
          } : undefined} data-id="element-8212" />
            <Tooltip content={<CustomTooltip data-id="element-8214" />} cursor={{
            stroke: '#94a3b8',
            strokeWidth: 1,
            strokeDasharray: '4 4'
          }} data-id="element-8213" />
            <Line type="monotone" dataKey="value" stroke={lineColor} strokeWidth={3} dot={{
            fill: '#fff',
            stroke: lineColor,
            strokeWidth: 2,
            r: 5
          }} activeDot={{
            fill: '#4f46e5',
            stroke: '#312e81',
            strokeWidth: 2,
            r: 7
          }} data-id="element-8215" />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>;
}